import { createContext, useContext } from 'react';

/**
 * PopupContext — provides popup-level data to children.
 *
 * close()  - programmatically close the containing popup
 * zIndex   - the popup's computed z-index (for dropdowns/tooltips inside)
 */
export const PopupContext = createContext(null);
export const usePopup = () => useContext(PopupContext);
